import { Draw, DrawRound } from '@Models';
import {
  tool_pairing_draw,
  tool_pairing_draw_create_dto,
  tool_pairing_draw_dto,
  tool_pairing_draw_select_dto,
  tool_pairing_team_draw,
} from '@Api';
import { inject, injectable } from 'inversify';
import { TYPES } from '@Types';
import { MatchMapper } from './MatchMapper';
import { TeamArmyMapper } from './TeamArmyMapper';

@injectable()
export class DrawMapper {
  @inject(TYPES.Mapper.MatchMapper) private _matchMapper!: MatchMapper;
  @inject(TYPES.Mapper.TeamArmyMapper) private _teamArmyMapper!: TeamArmyMapper;

  public map(item: tool_pairing_draw): Draw {
    return {
      id: item.id,
      teamId: item.my_team_id,
      myTeamArmyConfirmed: item.my_team_army_confirmed,
      myTeamArmyId: item.my_team_army_id,
      myTeamArmy: this._teamArmyMapper.map(item.my_team_army),
      propositionTeamArmyOneId: item.proposition_team_army_one_id,
      propositionTeamArmyOne:
        item.proposition_team_army_one != null
          ? this._teamArmyMapper.map(item.proposition_team_army_one)
          : null,
      propositionTeamArmyTwoId: item.proposition_team_army_two_id,
      propositionTeamArmyTwo:
        item.proposition_team_army_two != null
          ? this._teamArmyMapper.map(item.proposition_team_army_two)
          : null,
      propositionTeamArmyConfirmed: item.proposition_team_army_confirmed,
      selectedTeamArmyConfirmed: item.selected_team_army_confirmed,
      selectedTeamArmyId: item.selected_team_army_id,
      selectedTeamArmy:
        item.selected_team_army != null
          ? this._teamArmyMapper.map(item.selected_team_army)
          : null,
    } satisfies Draw as Draw;
  }

  mapDrawRound(item: tool_pairing_team_draw): DrawRound {
    return {
      myDrawExist: item.myDraw != null,
      myDraw: item.myDraw != null ? this.map(item.myDraw) : null,
      opponentDrawExist: item.opponentDraw != null,
      opponentDraw:
        item.opponentDraw != null ? this.map(item.opponentDraw) : null,
      matches: item.matches.map((m) => this._matchMapper.map(m)),
    } satisfies DrawRound as DrawRound;
  }

  public toCreateDto(item: Draw): tool_pairing_draw_create_dto {
    return {
      my_team_army_id: item.myTeamArmyId,
    } satisfies tool_pairing_draw_create_dto as tool_pairing_draw_create_dto;
  }

  public toPropositionDto(item: Draw): tool_pairing_draw_dto {
    return {
      proposition_team_army_one_id: item.propositionTeamArmyOneId!,
      proposition_team_army_two_id: item.propositionTeamArmyTwoId!,
    } satisfies tool_pairing_draw_dto as tool_pairing_draw_dto;
  }

  toSelectDto(draw: Draw): tool_pairing_draw_select_dto {
    return {
      select_id: draw.selectedTeamArmyId!,
    } satisfies tool_pairing_draw_select_dto as tool_pairing_draw_select_dto;
  }
}
